import React, { useState, useEffect } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { changePassword } from '../../../redux/modules/auth'
import { reduxForm, change } from 'redux-form'
import FormTextField from '../../../components/FormTextField'
import LanguageSelectorV2 from '../../../components/LanguageSelectorV2'
import { fetchLanguages, getPatient, setPatientLanguageById } from '../../../redux/actions'
import { languagesSelector, patientSelector } from '../../../redux/selectors'
import { required, passwordStrength, passwordMatch } from '../../../utilties/validators'
import Button from '@material-ui/core/Button'
import { useTheme, withStyles } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import * as cookies from '../../../utilties/cookies'

const styles = {
  input: {
    color: 'white',
    fontSize: '1.7rem'
  },

}

const useStyles = makeStyles((theme) => ({
  gridStyle: {
    padding: '4rem',
    [theme.breakpoints.down('sm')]: {
      padding: '3rem 2rem',
    }
  },
  formStyle: {
    width: 'calc(300px + 4rem)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(300px + 4rem)',
      width: '100%',
    }
  },
  inputLabel: {
    fontSize: '1.7rem'
  }
}))

const formName = 'changeLanguage'

const ChangeLanguage = ({ intl, handleSubmit, submitRequest, loadLanguages, loadPatient, languages, patient, setLanguage, dispatch, selectedLanguageId}) => {
  const [patientCookie] = useState(cookies.get('user'))

  const classes = useStyles()
  const theme = useTheme();

  const onSubmitForm = values => {
      setLanguage(patientCookie.id, values.languageId);
  }

  useEffect(() => {
          loadPatient()
          loadLanguages()
      },
      []);

  useEffect(() => {
      dispatch(change(formName, 'languageId', patient.languageId))
  }, patient && patient.languageId)

    return (
        <form data-testid="form-change-language" onSubmit={handleSubmit(onSubmitForm)} className={classes.formStyle}>
            <div>
                <Grid container direction="column" className={classes.gridStyle}>
                    <Grid item style={{ paddingBottom: '20px', textAlign: 'center', textTransform: 'uppercase' }}>
                        <Typography 
                          variant="h3"
                          data-testid="change-password-title">{intl.formatMessage({ id: 'app.general.language.change.title' })}</Typography>
                    </Grid>

                    <Grid item >
                        <LanguageSelectorV2
                            label={intl.formatMessage({ id: 'app.general.communicationOnLabel' })}
                            fullWidth
                            data={languages}
                            name="languageId"
                            variant="filled"
                        />
                    </Grid>

                    <Grid item style={{ textAlign: 'center' }}>
                        <Button
                            data-testid="change-password-button-submit"
                            variant='contained'
                            color='primary'
                            type="submit">
                            {intl.formatMessage({ id: 'app.general.language.change.save' })}
                        </Button>
                    </Grid>

                </Grid>
            </div>
        </form>
    )
}

const mapStateToProps = (state, ownProps) => ({
    languages: languagesSelector(state),
    patient: patientSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadLanguages: () => dispatch(fetchLanguages()),
    loadPatient: () => dispatch(getPatient()),
    setLanguage: (patientId, languageId) => dispatch(setPatientLanguageById(patientId, languageId))
})

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
    reduxForm({ form: formName }),
  withStyles(styles)
)

export default enhance(ChangeLanguage)
